/**
 * Takes actions creators by specified paths
 *
 * @param  {Array|Function} [actionPaths = []] - list of paths to actions
 * @param  {Object} actions — application actions
 * @return {Array} — prefetch action creators
 */
export default function getPrefetchActions() {
  var actionPaths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var actions = arguments.length > 1 ? arguments[1] : undefined;
  return actionPaths.map(function (actionDefinition) {
    if (typeof actionDefinition === 'function') return actionDefinition;
    var key = actionDefinition[0];
    var path = actionDefinition[1];
    if (actions[key] && actions[key][path]) return actions[key][path];
    throw new Error("Unable to find action by '".concat(actionDefinition.join('.'), "'"));
  });
}